document.addEventListener('DOMContentLoaded', function() {
  const partnersNav = document.querySelector('.partners-nav');
  if (partnersNav) {
    // Clone all list items
    const items = [...partnersNav.children];
    items.forEach(item => {
      const clone = item.cloneNode(true);
      partnersNav.appendChild(clone);
    });
  }
});